import { useEffect } from 'react';
import { useIsMobileBySize, useIsTabletBySize } from './screenSizeDetection.hook';


export default function useLockBodyScrollOnSelect() {
  const isMobile = useIsMobileBySize();
  const isTablet = useIsTabletBySize();

  useEffect(() => {
    if (!isMobile && !isTablet) return;

    const updateBodyOverflow = () => {
      // Busca dropdowns visibles
      const visibleDropdown = Array.from(
        document.querySelectorAll('.ant-select-dropdown')
      ).some(
        (el) => getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden'
      );

      document.body.style.overflow = visibleDropdown ? 'hidden' : '';
    };

    const observer = new MutationObserver(updateBodyOverflow);

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['style', 'class'],
    });

    const interval = setInterval(updateBodyOverflow, 300);

    // Limpieza
    return () => {
      observer.disconnect();
      clearInterval(interval);
      document.body.style.overflow = '';
    };
  }, [isMobile, isTablet]);
}